// extracted by mini-css-extract-plugin
module.exports = {"newsGrid":"actual-list_newsGrid__CW_eJ"};